import { render, staticRenderFns } from "./caseClip_Fun.vue?vue&type=template&id=09614548&scoped=true"
import script from "./caseClip_Fun.vue?vue&type=script&lang=js"
export * from "./caseClip_Fun.vue?vue&type=script&lang=js"
import style0 from "./caseClip_Fun.vue?vue&type=style&index=0&id=09614548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09614548",
  null
  
)

export default component.exports